import React from 'react';
import { CalendarClock, Hourglass } from 'lucide-react';
import { RESULTADO_LABEL, RESULTADO_PUNTO } from 'lib/cables';

// Texto corto para las fichas del tablero (caben en una línea a 390 px).
const RESULTADO_CORTO = { apto_con_observaciones: 'Observaciones' };

// Resultado de la inspección de un cable, discreto como el riesgo de los
// árboles: punto de color con el texto (nunca solo color). "No apto" sube a
// texto de error, sin fondo ni borde: se nota, pero no grita.
export function ResultadoDiscreto({ resultado, grande = false, corto = false, className = '', textoVacio = 'Sin inspección anual' }) {
  const tam = grande ? 'gap-2 text-base font-semibold' : 'gap-1.5 text-xs font-medium';
  const punto = grande ? 'h-2.5 w-2.5' : 'h-2 w-2';
  const nowrap = grande ? '' : 'whitespace-nowrap';
  if (!resultado) {
    return (
      <span className={`inline-flex items-center ${nowrap} text-muted-foreground ${tam} ${className}`}>
        <span className={`${punto} shrink-0 rounded-full border border-muted-foreground/60`} aria-hidden="true" />{textoVacio}
      </span>
    );
  }
  const color = resultado === 'no_apto' ? 'text-error' : grande ? 'text-foreground' : 'text-muted-foreground';
  return (
    <span data-resultado={resultado} className={`inline-flex items-center ${nowrap} ${tam} ${color} ${className}`}>
      <span className={`${punto} shrink-0 rounded-full ${RESULTADO_PUNTO[resultado] || 'bg-muted-foreground'}`} aria-hidden="true" />
      <span className="sr-only">Resultado: </span>{(corto && RESULTADO_CORTO[resultado]) || RESULTADO_LABEL[resultado] || resultado}
    </span>
  );
}

// Marcas secundarias de las fichas: atenuadas, con ícono, sin fondo rojo.
export function MarcaRevision({ texto = 'Revisión pendiente' }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground">
      <CalendarClock size={12} aria-hidden="true" className="shrink-0" />{texto}
    </span>
  );
}

export function MarcaCambio({ texto = 'Cambio vencido' }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground" data-cambio-vencido>
      <Hourglass size={12} aria-hidden="true" className="shrink-0" />{texto}
    </span>
  );
}
